import vehicleTypeTranslate from '../utils/vehicleTypeTranslate'
import { formatCurrency, formatWithThousandSep } from '../utils/utils'

export interface VehicleFrameType {
  plate?: string
  type?: string
  brand?: string
  model?: string
  version?: string
  year?: number
  color?: string
  color_format?: string
  odometer?: number
  chassisId?: string
  engineId?: string
  price?: number
}
import { useFeatureFlag } from '../hooks/useFeatureFlag'

import { VehicleFrame as VehicleFrameV2 } from './VehicleFrameV2'

export const VehicleFrame: React.FC<{ vehicle: VehicleFrameType; noPrice?: boolean }> = ({ vehicle, noPrice }) => {
  const { useNewDocumentUI } = useFeatureFlag()

  if (useNewDocumentUI) return <VehicleFrameV2 vehicle={vehicle} noPrice={noPrice} />

  const type_format = vehicleTypeTranslate[vehicle.type ?? ''] || (vehicle.type ?? '')
  const odometer_format = formatWithThousandSep(vehicle.odometer ?? 0)
  const price_format = formatCurrency(vehicle.price ?? 0)

  return (
    <>
      <div className="mb-2">
        <span className="text-[1.5em]">Datos del Vehículo</span>
      </div>
      <div className="grid grid-cols-6 gap-x-2">
        <div className="">Tipo</div>
        <div className="col-span-2 font-bold">{type_format}</div>
        <div className="">Marca</div>
        <div className="col-span-2 font-bold">{vehicle.brand}</div>
        <div className="">Modelo</div>
        <div className="col-span-2 font-bold">{`${vehicle.model} ${vehicle.version}`}</div>
        <div className="">Año</div>
        <div className="col-span-2 font-bold">{vehicle.year}</div>
        <div className="">Color</div>
        <div className="col-span-2 font-bold">{vehicle.color_format}</div>
        <div className="">Kilometraje</div>
        <div className="col-span-2 font-bold">{odometer_format}</div>
        <div className="">N° Chassis</div>
        <div className="col-span-2 font-bold">{vehicle.chassisId}</div>
        <div className="">N° Motor</div>
        <div className="col-span-2 font-bold">{vehicle.engineId}</div>
        <div className="">Patente</div>
        <div className="col-span-2 font-bold">{vehicle.plate}</div>
        {!noPrice && (
          <>
            <div className="">Valor</div>
            <div className="col-span-2 font-bold">{price_format}</div>
          </>
        )}
      </div>
    </>
  )
}
